"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsight = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var base_1 = require("../base");
/**
 * @internal
 */
function useInsight(config, deps) {
    var insight = config.insight;
    var backend = base_1.useBackendStrict(config.backend, "useInsight");
    var workspace = base_1.useWorkspaceStrict(config.workspace, "useInsight");
    var promise = insight ? function () { return backend.workspace(workspace).insights().getInsight(insight); } : null;
    return base_1.useCancelablePromise({ promise: promise }, tslib_1.__spread([
        backend,
        workspace,
        insight ? sdk_model_1.objRefToString(insight) : "__insightRef__"
    ], (deps !== null && deps !== void 0 ? deps : [])));
}
exports.useInsight = useInsight;
//# sourceMappingURL=useInsight.js.map